module.exports = __webpack_public_path__ + "media/instagram/instagram_action_bar-976e73d5.png";